import { getCurrentUrl } from "preact-router";
import { useState } from "preact/hooks";
import { ThemeToggle } from "./ThemeToggle";
import "./Navbar.css";

const navItems = [
  { href: "/", label: "Overview" },
  { href: "/clients", label: "Clients" },
  { href: "/hardware", label: "Hardware" },
  { href: "/speedtest", label: "Speedtest" },
];

export function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const currentPath = getCurrentUrl();

  return (
    <header class="navbar">
      <div class="navbar__container">
        <a href="/" class="navbar__brand">
          <span class="navbar__logo" aria-hidden="true">
            📡
          </span>
          <span class="navbar__title">Monitoring RT/RW Net</span>
        </a>

        <nav class="navbar__nav" aria-label="Main navigation">
          <ul class="navbar__links" role="menubar">
            {navItems.map((item) => {
              const isActive = currentPath === item.href;
              return (
                <li class="navbar__item" role="none" key={item.href}>
                  <a
                    href={item.href}
                    class={`navbar__link ${isActive ? "navbar__link--active" : ""}`}
                    role="menuitem"
                    aria-current={isActive ? "page" : undefined}
                  >
                    {item.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </nav>

        <div class="navbar__actions">
          <ThemeToggle />
          <button
            class="navbar__hamburger"
            type="button"
            aria-label="Toggle navigation"
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((prev) => !prev)}
          >
            <span class="navbar__hamburger-bar"></span>
            <span class="navbar__hamburger-bar"></span>
            <span class="navbar__hamburger-bar"></span>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div class="navbar__mobile">
          <nav aria-label="Mobile navigation">
            <ul class="navbar__mobile-links">
              {navItems.map((item) => {
                const isActive = currentPath === item.href;
                return (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      class={`navbar__mobile-link ${isActive ? "navbar__mobile-link--active" : ""}`}
                      aria-current={isActive ? "page" : undefined}
                      onClick={() => setMobileOpen(false)}
                    >
                      {item.label}
                    </a>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      )}
    </header>
  );
}
